import { render, staticRenderFns } from "./PayslipScan.vue?vue&type=template&id=9d853be2&scoped=true"
import script from "./PayslipScan.vue?vue&type=script&lang=js"
export * from "./PayslipScan.vue?vue&type=script&lang=js"
import style0 from "./PayslipScan.vue?vue&type=style&index=0&id=9d853be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d853be2",
  null
  
)

export default component.exports